import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const LoadServiceTitles = () => {
  // Get the service details from Redux state
  const serviceDetails = useSelector(
    (state) => state.dashboard.dashboardData.ServiceDetails
  );

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const navigate = useNavigate();
  const {isChatVisible, toggleChat, showChat } = useChat();

  // Function to handle click and navigate to a different component
  const handleNavigation = (service) => {
    const updatedDescription = (isHighmarkPortal && service.ServiceDescription === "WIN for Him")
      ? "Fertility and Family Building for Him"
      : service.ServiceDescription;
  
    if (service.ServiceDescription !== "Child Development") {
      navigate(`/feedServices`, {
        state: {
          link: service.WebLink,
          description: updatedDescription,
          videolink: service.VideoLink,
          documentlink: service.DocumentLink,
        },
      });
    } else {
      navigate(`/child-development`, {
        state: {
          link: service.WebLink,
          description: updatedDescription,
        },
      });
    }
  };
  
  const handleBackClick = () => {
    navigate('/home'); // Redirects to the home page
  };
  return (
    <>    
    
    {isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">{t('education')}</h2>
          </div>:
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('education')}</h2>
          </div>
      }

    {/* <div className="col-md-12 col-lg-6 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('backbutton')}</span></button>
        <h2 className="page-heading">{t('education')}</h2>
      </div> */}

      
        {serviceDetails && serviceDetails.length > 0 ? (
          <div className="col-md-12 schedules-wrapper">
            {serviceDetails.map((service) => (
              <div
                className="schedule-block-new"
                key={service.ServiceId}
                onClick={() => handleNavigation(service)} // Pass description on click
                style={{ cursor: "pointer" }} // Add cursor style to indicate clickability
              >
                <span className="schedule-block-left-logo"></span>
                <span className="schedule-block-text">
  {(isHighmarkPortal && service.ServiceDescription === "WIN for Him")
    ? "Fertility and Family Building for Him"
    : service.ServiceDescription}
</span>

              </div>
            ))}
          </div>
        ) : (
          <div className="no-data-available">{t('servicetitle')}</div>
        )}
         {/* {isChatVisible && <ChatBotWindow />} */}
      </>
  );
};

export default LoadServiceTitles;
